define('v3/Common/Services/boundaryPercentileService',[
	'v3/Common/Models/enums'
], function (enums) {
	return {
		getLegendTypeByPercentile: function (percentile) {
			if (percentile == null) {
				return null;
			}

			if (percentile < 20) {
				return this._getLegendType(percentile, 5);
			} else if (percentile < 40) {
				return this._getLegendType(percentile, 4);
			} else if (percentile < 60) {
				return this._getLegendType(percentile, 3);
			} else if (percentile < 80) {
				return this._getLegendType(percentile, 2);
			} else {
				return this._getLegendType(percentile, 1);
			}
		},

		getLegendTypeByScore: function (score, percentile) {
			if (score == null) {
				return null;
			}

			switch (score) {
			case 1: return this._getLegendType(percentile, 5);
			case 2: return this._getLegendType(percentile, 4);
			case 3: return this._getLegendType(percentile, 3);
			case 4: return this._getLegendType(percentile, 2);
			case 5: return this._getLegendType(percentile, 1);
			}
		},

		_getLegendType: function (percentile, type) {
			return {
				percentile: percentile,
				legendType: enums.legendType['legend' + type],
				legendLetter: enums.legendType['legendLetter' + type],
				legendNumeral: enums.legendType['legendNumeral' + type],
				name: enums.legendType.getLocalizedName(enums.legendType['legend' + type])
			};
		}
	};
});

